export default {"src":"/_next/static/media/defaultSmallUsedCar.ec5f2289.svg","height":100,"width":136};